import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FileNameType} from './see-details/see-details.component';

export interface ShareItemFileDetails{
  id: number;
  token: string;
  name: string;
}

export interface ShareItem {
  token: string;
  user_email: string;
  files_total: number;
  files_size: number;
  expires_at: Date;
  was_downloaded: boolean;
  has_password: boolean;
  date_created: Date;
  state: string;
  last_download: Date;
  shared_with: string[];
  email_subject: string;
  email_body: string;
  is_selected: boolean;
  dicoms: ShareItemFileDetails[];
  images: ShareItemFileDetails[];
  videos: ShareItemFileDetails[];
  texts: ShareItemFileDetails[];
}

@Component({
  selector: 'app-share-item',
  templateUrl: './share-item.component.html',
  styleUrls: ['./share-item.component.scss']
})
export class ShareItemComponent implements OnInit {
  @Input() item: ShareItem;
  @Output() updateShareItems: EventEmitter<any> = new EventEmitter();
  @Output() revokeAccess: EventEmitter<string[]> = new EventEmitter();

  filenames: FileNameType[];

  constructor() { }

  ngOnInit(): void {
    this.filenames = this.item.dicoms.map(i => {
      return {name: i.name, type: 'dicom'};
    });
    this.filenames = this.filenames.concat(this.item.texts.map(i => {
      return {name: i.name, type: 'text'};
    }));
    this.filenames = this.filenames.concat(this.item.videos.map(i => {
      return {name: i.name, type: 'video'};
    }));
    this.filenames = this.filenames.concat(this.item.images.map(i => {
      return {name: i.name, type: 'image'};
    }));
  }

  selectByClick() {
    this.item.is_selected = !this.item.is_selected;
    this.updateShareItems.emit();
  }

  revoke() {
    this.revokeAccess.emit([this.item.token]);
  }

}
